import { jsxs as s, jsx as o } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as c } from "../../../context/theme/hooks.js";
import "../../layout/Stack/Stack.js";
import n from "../../layout/Box/Box.js";
import { styledWithConfig as l } from "../../layout/Box/utils.js";
import "react";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
const u = l("input");
function B(r) {
  return function(i) {
    const { name: t, checked: p, onChange: m, disabled: e } = i, h = c();
    return /* @__PURE__ */ s(
      n,
      {
        component: "label",
        htmlFor: t,
        cursor: e ? "not-allowed" : "pointer",
        display: "block",
        width: "fit-content",
        height: "fit-content",
        focusVisibleWithinStyles: {
          outline: `2px solid ${h["primary-medium-content"]}`,
          borderRadius: "xlarge"
        },
        children: [
          /* @__PURE__ */ o(
            u,
            {
              id: t,
              name: t,
              type: "checkbox",
              onChange: m,
              disabled: e,
              checked: p,
              width: "1px",
              height: "1px",
              position: "absolute",
              top: "auto",
              left: "-10000px"
            }
          ),
          /* @__PURE__ */ o(
            n,
            {
              width: "1px",
              height: "1px",
              position: "absolute",
              top: "auto",
              left: "-10000px",
              children: t
            }
          ),
          /* @__PURE__ */ o(r, { ...i })
        ]
      }
    );
  };
}
export {
  B as makeCustomCheckbox
};
